import styled from 'styled-components';

import { makeSlot } from './slots';


const NoticeS = styled.div`
    grid-area: notice;
    color: #7E8491;
    font-size: .85em;
    padding-top: .4em;
`;

export const Notice = makeSlot('notice')(NoticeS);
